<div class="tw-box-border tw-cursor-pointer tw-overflow-hidden tw-rounded-md tw-border tw-border-solid tw-text-[var(--sys-text)]"
     [ngClass]="[
        selected ? 'tw-border-[color:var(--sys-cashregister-cart-accent)]' : 'tw-border-[color:var(--sys-cashregister-cart-group-bg)]',
        flash ? 'tw-bg-[var(--sys-cashregister-cart-flash)]' : (selected ? 'tw-bg-[var(--sys-cashregister-cart-selected-bg)]' : 'tw-bg-[var(--sys-card)]'),
        grouped ? 'tw-border-l-6 tw-border-l-[color:var(--sys-cashregister-cart-accent)]' : '',
        saleItem.sale_item_parent_uuid ? 'tw-ml-4' : '',
        flash ? 'tw-transition-colors tw-duration-0' : (flashFading ? 'tw-transition-colors tw-duration-[2500ms]' : ''),
        disabled ? 'tw-pointer-events-none tw-opacity-50' : ''
     ]"
     (pointerdown)="resetGesture()"
     (click)="rowClick.emit()">
    <div class="tw-flex tw-flex-col tw-px-2"
         tilbyGestures
         (swipeLeft)="gestureDone(); swipeLeft.emit()" (swipeRight)="gestureDone(); swipeRight.emit()"
         (longPress)="gestureDone(); longPress.emit()" (mousedown)="rowMouseDown.emit()">
        <div class="tw-flex tw-min-h-9 tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-tracking-tight">
            <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-1.5">
                @if (saleItem.$menuIndex) {
                    <div class="tw-flex tw-items-center tw-h-4 tw-gap-1 tw-text-[var(--sys-secondary-text)]">
                        <mat-icon class="tw-max-w-fit">link</mat-icon>
                        <span>{{ saleItem.$menuIndex }}</span>
                    </div>
                }
                <span class="tw-min-w-0" [class.tw-truncate]="!expanded" [class.tw-break-words]="expanded">
                    @if (saleItem.half_portion) {
                        <span>½ </span>
                    }
                    {{ (saleItem.name || '').toTitleCase() }}
                </span>
                @if (saleItem.request_weighing) {
                    <mat-icon class="material-icons-outlined tw-shrink-0 tw-text-lg tw-text-center tw-max-w-fit" color="warn">scale</mat-icon>
                }
                @if (saleItem.$unavailable) {
                    <mat-icon class="material-icons-outlined tw-shrink-0 tw-text-lg tw-text-center tw-max-w-fit" color="warn">widgets</mat-icon>
                }
                @if (!expanded && hasDiscount) {
                    <mat-icon class="material-icons-outlined tw-shrink-0 tw-text-lg tw-text-center tw-max-w-fit tw-text-[var(--sys-cashregister-cart-accent)]">percent</mat-icon>
                }
                @if (!expanded && hasDetails) {
                    <mat-icon class="material-icons-outlined tw-shrink-0 tw-text-lg tw-text-center tw-max-w-fit tw-text-[var(--sys-cashregister-cart-accent)]">edit_note</mat-icon>
                }
            </div>
            <span class="tw-shrink-0 tw-text-right tw-tabular-nums">{{ isHidePrices ? '***' : ((saleItem.$partialAmount || 0) | tilbyCurrency) }}</span>
        </div>
        <div class="tw--mx-2 tw-flex tw-min-h-7 tw-cursor-pointer tw-items-center tw-gap-2 tw-px-2 tw-pb-1 tw-text-xs"
             (click)="onToggle($event)">
            <span class="tw-min-w-0 tw-flex-1 tw-tabular-nums">
                {{ saleItem.quantity }}x{{ isHidePrices ? '***' : (saleItem.price | tilbyCurrency) }}
                @if (vatLabel) {
                    <span class="tw-ml-1 tw-text-[var(--sys-secondary-text)]">({{ vatLabel }})</span>
                }
                @if (saleItem.type === 'gift') {
                    <span class="tw-ml-1 tw-text-[var(--sys-secondary-text)]">{{ 'ORDER.SALE.GIFT' | translate }}</span>
                }
            </span>
            @if (sent) {
                <mat-icon class="tw-shrink-0 tw-text-lg" fontIcon="done_all"/>
            }
            <button type="button"
                    class="tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-[var(--sys-cashregister-cart-accent-soft)] tw-p-0 tw-text-[var(--sys-text)]"
                    [attr.aria-expanded]="expanded"
                    (click)="onToggle($event)">
                <mat-icon class="tw-h-[18px] tw-w-[18px] tw-text-[18px] tw-transition-transform" [class.tw-rotate-180]="expanded">expand_more</mat-icon>
            </button>
        </div>
    </div>

    @if (expanded && hasExpandedContent) {
        <div class="tw-flex tw-cursor-pointer tw-flex-col tw-gap-1 tw-px-2 tw-pb-3 tw-pt-1 tw-text-xs"
             (click)="onToggle($event)">
            @if (saleItem.type === 'refund' && saleItem.refund_cause_description) {
                <div>{{ saleItem.refund_cause_description }}</div>
            }
            @if (saleItem.not_discountable) {
                <span class="tw-text-[var(--sys-cashregister-cart-danger)]">{{ 'ITEMS.SHOWCASE.NOT_DISCOUNTABLE' | translate }}</span>
            }
            @for (variation of saleItem.variations; track $index) {
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-text-[var(--sys-secondary-text)]">
                    <span class="tw-truncate">{{ variation.name }} - {{ (variation.quantity ?? 1) == 1 ? '' : variation.quantity + 'x - ' }}{{ variation.value }}</span>
                    <span class="tw-shrink-0 tw-tabular-nums">{{ isHidePrices ? '***' : ((((saleItem.quantity || 0) * (variation.quantity ?? 1) * (variation.price_difference || 0)) | tilbyCurrency) || '-') }}</span>
                </div>
            }
            @for (ingredient of saleItem.ingredients; track $index) {
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-text-[var(--sys-secondary-text)]">
                    <span class="tw-truncate tw-whitespace-pre">{{ ingredient.type == 'removed' ? '-' : '+' }} {{ ((ingredient.quantity || 0) > 1) ? ingredient.quantity + 'x ' : '' }}<span [class.tw-line-through]="ingredient.type == 'removed'">{{ ingredient.name }}</span></span>
                    @if (ingredient.price_difference && (ingredient.type == 'added' || (ingredient.type == 'removed' && ingredientsRemovalAffectsPrice))) {
                        <span class="tw-shrink-0 tw-tabular-nums">{{ isHidePrices ? '***' : (ingredient.type == 'removed' ? '-' : '') + (((saleItem.quantity || 0) * (ingredient.price_difference || 0) * Math.abs(ingredient.quantity || 0)) | tilbyCurrency) }}</span>
                    }
                </div>
            }
            @if (saleItem.notes) {
                <div class="tw-break-words tw-text-[var(--sys-secondary-text)]">{{ saleItem.notes }}</div>
            }
            @for (priceChange of saleItem.price_changes; track $index) {
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-font-medium tw-text-[var(--sys-cashregister-cart-accent)]"
                     tilbyGestures
                     (swipeLeft)="gestureDone(); removePriceChange.emit(priceChange)"
                     (longPress)="gestureDone(); longPress.emit()">
                    <span class="tw-min-w-0 tw-flex-1">{{ $any(priceChange) | tilbyPriceChange:priceChangeDescriptions }}</span>
                    <span class="tw-shrink-0 tw-tabular-nums">{{ isHidePrices ? '***' : ((priceChange.amount || 0) | tilbyCurrency) }}</span>
                </div>
            }
        </div>
    }
</div>
